module.exports = __webpack_public_path__ + "img/blue-leaf.a27a9ffa.svg";